import { SpacingsValues } from '@picsart/cascade';
import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../styles';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      backgroundColor: 'var(--x-bg-5)',
      paddingBlock: SpacingsValues.s56,
    },
    container: {
      marginInline: 'auto',
      width: 'min(100%, var(--max-width-02))',
    },
    title: {
      fontWeight: 500,
      marginBottom: SpacingsValues.s48,
      marginInline: 'auto',
      paddingInline: 24,
      textAlign: 'center',

      [mediaQuery(breakpoints.laptop)]: {
        marginInline: SpacingsValues.s24,
        marginBottom: 16,
      },
      [mediaQuery(breakpoints.mobile)]: {
        fontSize: 30,
        lineHeight: '36px',
      },
    },

    content: {
      display: 'flex',
      gap: SpacingsValues.s48,
      justifyContent: 'center',
      listStyleType: 'none',
      marginInline: 'auto',
      padding: 24,
      width: 'min(100%, 1144px)',

      [mediaQuery(breakpoints.desktop)]: {
        justifyContent: 'center',
        flexWrap: 'wrap',
      },

      [mediaQuery(breakpoints.mobile)]: {
        alignItems: 'center',
        flexDirection: 'column',
      },
    },
    item: {
      flexShrink: 0,
      textAlign: 'center',
      width: 'min(238px, calc(100% - 54px))',

      '& a': {
        color: 'var(--x-accent-2-1)',

        '&:hover': {
          color: 'var(--x-accent-2-1)',
        },
      },
    },

    img: {
      marginBottom: SpacingsValues.s24,
      maxWidth: '100%',
      '&.href': {
        cursor: 'pointer',
      },
    },
    itemTitle: {
      fontWeight: 600,
      marginBottom: 4,
      textAlign: 'center',
    },
  }),
  {
    name: 'ImageWithTextListContained',
  },
);

export default useStyles;
